<template>
  <code :class="$style.code"><slot /></code>
</template>

<script>
export default {
  name: 'b-code',
}
</script>

<style lang="scss" module>
.code {
  background: var(--b-color-bg-secondary);
  color: var(--b-color-primary);
  padding: var(--b-gap-1) var(--b-gap-2);
  display: inline-block;
  border-radius: var(--b-border-radius);
  font-family: var(--b-font-family-monospaced);
  font-size: var(--b-font-size-h7);
  white-space: nowrap;
}
</style>
